import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './mobile-optimizations.css';
import App from './App';


const rootElement = document.getElementById('root');

// Support for react-snap pre-rendering
if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered content
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Normal render for development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
